import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-complete",
  "use": "icon-complete-usage",
  "viewBox": "0 0 1088 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1088 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-complete\"><defs><style type=\"text/css\"></style></defs><path d=\"M524.48 0a512 512 0 1 0 0 1024 512 512 0 0 0 0-1024z m282.048 379.776l-349.184 348.096a37.12 37.12 0 0 1-52.48 0L252.224 575.744a36.864 36.864 0 0 1 0-52.352 37.12 37.12 0 0 1 52.48 0l126.4 126.08 322.88-321.984a37.12 37.12 0 0 1 52.48 0 36.864 36.864 0 0 1 0.064 52.288z\" p-id=\"14000\" fill=\"#1890ff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/complete.svg
// module id = PGk/
// module chunks = 0